import React from 'react';
import { colorsPalette } from '../../theme';
import useStyles from './styles';

const AccountIcon = (props) => {
  const color = props?.color || colorsPalette.white;
  const classes = useStyles()();

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
      color={color}
    >
      <path
        className={classes.element}
        d="M22,21.996A7.99609,7.99609,0,0,0,14.004,14H9.996A7.99609,7.99609,0,0,0,2,21.996V22H22Z"
      />
      <circle
        className={classes.element}
        cx="12"
        cy="8"
        r="6"
        transform="translate(-0.08813 0.1338) rotate(-0.63652)"
      />
    </svg>
  );
};

export default AccountIcon;
